<template lang="pug">

  div

    //-
      -
      - BUSCA
      -
      -

    v-dialog(v-model="visible" max-width="560px" :persistent="loading")

      .dialogHeader

        .dialogHeaderTitle
          | Cadastre um paciente

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="close")

      .dialogBody

        .dialogBodyContent

          //-
            -
            - FORMULÁRIO DE PRÉ CADASTRO
            -
            -

          .registerPatientTitle.mb-4
            | Preencha os campos para criar o paciente:

          .registerPatientForm

            //-
              - Grupos
              -

            .registerPatientBlock
              sos-select(:removeBorder="true" :defaultEmpty="'Estado'" :items="processedGroups" @sosSelectChanged="onSelectGroup" :fullscreen="true" :fullscreenTitle="'Grupos'" :fullscreenAutoWidth="false" :default="newPatientUF" :disabled="processedGroups.length === 0 || lockGroupSelection").registerPatientField.registerPatientField--noSpacing

            .err(v-if="!!errPatientUF === true") {{ errPatientUF }}
            .err.err--notice(v-if="lockGroupSelection") Gostaria de selecionar outra opção? Vá até a lista de grupos ou perfil e abra o menu "Novo paciente".

            //-
              - Unidade
              -

            .registerPatientBlock
              v-icon(size="18").registerPatientFieldIcon mdi-city-variant-outline
              input(v-model="newPatientUnitName" type="text" maxlength="64" placeholder="Unidade" readonly).registerPatientField.registerPatientField--group
              sos-button(:disabled="loading || newPatientUF.length === 0" @buttonClick="openFindGroupDialog" buttonLabel="" color="purple" size="small" buttonIcon="mdi-magnify" buttonIconSize="16").searchGroupButton

            .err(v-if="!!errPatientUnit === true") {{ errPatientUnit }}

            //-
              - Nome e Sobrenome
              -

            div

              .registerPatientBlock--50.registerPatientBlock--verticalTop.registerPatientBlock--left
                .registerPatientBlock
                  v-icon(size="18").registerPatientFieldIcon mdi-account
                  input(v-model="newPatientName" :disabled="loading" type="text" maxlength="64" placeholder="Nome").registerPatientField
                .err(v-if="!!errPatientName === true") {{ errPatientName }}

              .registerPatientBlock--50.registerPatientBlock--verticalTop.registerPatientBlock--right
                .registerPatientBlock
                  input(v-model="newPatientLastname" :disabled="loading" type="text" maxlength="64" placeholder="Sobrenome").registerPatientField.registerPatientField--noIcon
                .err(v-if="!!errPatientLastname === true") {{ errPatientLastname }}

            //- .err(v-if="!!errPatientName === true || !!errPatientLastname === true")
              span(v-if="!!errPatientName === true") {{ errPatientName }}
              span(v-if="!!errPatientLastname === true") {{ errPatientLastname }}

            //-
              - Data de nascimento
              -

            .registerPatientBlock
              v-icon(size="18").registerPatientFieldIcon mdi-cake
              date-picker(v-model="newPatientBirthdate" placeholder="Data de nascimento" :clearable="false" :editable="false" :multiple="false" :mode="'date'" :lang="lang" valueType="format" format="DD/MM/YYYY" @change="setBirthdate").registerPatientField

            .err(v-if="!!errPatientBirthdate === true") {{ errPatientBirthdate }}

            //-
              - CPF
              -

            .registerPatientBlock
              v-icon(size="18").registerPatientFieldIcon mdi-card-account-details
              input(:value="newPatientCpf" :disabled="loading" type="text" maxlength="14" placeholder="CPF" @input="onCpfChange" @paste="onCpfChange").registerPatientField

            .err(v-if="!!errPatientCpf === true") {{ errPatientCpf }}

            //-
              - CNS
              -

            .registerPatientBlock
              v-icon(size="18").registerPatientFieldIcon mdi-id-card
              input(:value="newPatientCNS" :disabled="loading" type="tel" maxlength="18" placeholder="CNS" @input="onCnsChange" @paste="onCnsChange").registerPatientField

            .err(v-if="!!errPatientCNS === true") {{ errPatientCNS }}

            //-
              - Telefone
              -

            .registerPatientBlock
              v-icon(size="18").registerPatientFieldIcon mdi-phone
              input(:value="newPatientPhone" :disabled="loading" type="tel" maxlength="15" placeholder="Telefone ou celular" @input="onPhoneChange" @paste="onPhoneChange").registerPatientField

            .err(v-if="!!errPatientPhone === true") {{ errPatientPhone }}

            //-
              - E-mail
              -

            .registerPatientBlock
              v-icon(size="18").registerPatientFieldIcon mdi-email
              input(v-model="newPatientEmail" :disabled="loading" type="text" maxlength="128" placeholder="(Opcional) E-mail").registerPatientField

            .err(v-if="!!errPatientEmail === true") {{ errPatientEmail }}

          //-
            -
            - BOTÃO PARA PRÉ CADASTRAR PACIENTE
            -
            -

          .text-right
            sos-button(class="mt-6" :disabled="loading" @buttonClick="patientPreRegister" buttonLabel="Cadastrar" color="success" size="medium" buttonIcon="mdi-account-plus" buttonIconSize="20")

    //-
      -
      - Modal AVISO
      -
      -

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

    //-
      -
      - Modal "SEARCH GROUP"
      -
      -

    dialog-find-group(ref="modalFindGroup" @return="dialogSearchGroupAction")

</template>

<script>

  import { mapState } from 'vuex'

  import { apiGetUserId } from '@/services/firebase'
  import { apiCreatePatient } from '@/services/consultations'

  import { validateBrazilianCpf, validateBrazilianCNS } from '@/functions/index.js'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  import SosButton from '@/components/SosButton'
  import SosNavigation from '@/components/SosNavigation'
  import SosSelect from '@/components/SosSelect'

  import ConfirmDialog from '@/modals/ConfirmDialog'
  import DialogFindGroup from '@/modals/DialogFindGroup'

  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'

  //
  //
  //

  const applyPhoneMask = phone => {
    let vPhone = String(phone).trim().replace(/[^0-9]/g, '')

    const lPhone = vPhone.length

    vPhone = vPhone.replace(/^(\d\d)(\d)/g, '($1) $2')

    vPhone = lPhone > 10 ? vPhone.replace(/(\d{5})(\d)/, '$1-$2').slice(0, 15) : vPhone.replace(/(\d{4})(\d)/, '$1-$2').slice(0, 14)

    return vPhone
  }

  export default {
    name: 'DialogCreatePatient',

    components: {
      'sos-button': SosButton,
      'sos-navigation': SosNavigation,
      'sos-select': SosSelect,

      'confirm-dialog': ConfirmDialog,
      'dialog-find-group': DialogFindGroup,

      'date-picker': DatePicker,
    },

    computed: {
      ...mapState(['groups', 'loadingGroups']),
    },

    mixins: [
      confirmDialogMixin,
    ],

    data () {
      return {
        visible: false,

        loading: false,

        processedGroups: [],
        lockGroupSelection: false,

        newPatientName: '',
        newPatientLastname: '',
        newPatientBirthdate: '',
        newPatientCpf: '',
        newPatientCNS: '',
        newPatientPhone: '',
        newPatientEmail: '',
        newPatientUnitId: '',
        newPatientUnitName: '',
        newPatientUF: '',

        /* newPatientName: 'Teste',
        newPatientLastname: 'Neoplan 123',
        newPatientBirthdate: '13/11/1992',
        newPatientCpf: '419.284.088-00',
        newPatientCNS: '896 3032 7172 0005',
        newPatientPhone: '(18) 99647-8007',
        newPatientEmail: 'abc123@agencianeoplan.com.br',
        newPatientUnitId: '',
        newPatientUnitName: '',
        newPatientUF: '', */

        errPatientName: '',
        errPatientLastname: '',
        errPatientBirthdate: '',
        errPatientCpf: '',
        errPatientCNS: '',
        errPatientPhone: '',
        errPatientEmail: '',
        errPatientUnit: '',
        errPatientUF: '',

        // DATE PICKER SETTING
        lang: {
          formatLocale: {
            // MMMM
            months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            // MMM
            monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            // dddd
            weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
            // ddd
            weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
            // dd
            weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
            // weekdaysMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
          },
          yearFormat: 'YYYY',
          monthFormat: 'MMMM',
        },
      }
    },

    watch: {
      visible: {
        // the callback will be called immediately after the start of the observation
        handler (visible, previousVisible)
        {
          if (!!previousVisible === true && !!visible === false)
          {
            this.clear()

            this.$emit('close', false)
          }
        },
      },

      '$store.state.loadingGroups': {
        handler (newData, _) {
          if (newData === 'LOADED') this.processGroups()
        },
        // the callback will be called immediately after the start of the observation
        immediate: true,
        deep: true,
      },

      /* newPatientBirthdate: {
        // the callback will be called immediately after the start of the observation
        handler (newValue, oldValue)
        {
          // [06/02/25] console.log('::: Set Birthdate [newPatientBirthdate]:', oldValue, newValue)
        },
      }, */
    },

    /* mounted () {
    },

    beforeDestroy () {
    }, */

    methods: {
      //
      //
      // ABRE O DIALOG
      //
      //

      open ()
      {
        const routeGroupID = this.$route.params.groupID || ''

        this.newPatientUF = routeGroupID

        if (this.loadingGroups === 'LOADED') this.processGroups()

        this.lockGroupSelection = !!routeGroupID === true

        this.visible = true
      },

      close ()
      {
        if (this.loading) return false

        this.visible = false
      },

      //
      //
      // ?
      //
      //

      processGroups ()
      {
        this.processedGroups = this.groups.map(u => (/* OPÇÕES DO SOS-SELECT */ {
          key: `u_${u.groupID}`,
          value: u.groupID,
          text: `<div class="managerItem"><span class="managerImage" style="background-image: url('${u.groupImage}')" title="${u.groupName}"></span><span class="managerName" title="${u.groupName}">${u.groupName}</span></div>`,
        }))
      },

      onSelectGroup (selected)
      {
        this.newPatientUF = selected
      },

      //
      //
      // LIMPEZA
      //
      //

      clear ()
      {
        this.loading = false

        this.processedGroups = []
        this.lockGroupSelection = false

        this.newPatientName = ''
        this.newPatientLastname = ''
        this.newPatientBirthdate = ''
        this.newPatientCpf = ''
        this.newPatientCNS = ''
        this.newPatientPhone = ''
        this.newPatientEmail = ''
        this.newPatientUnitId = ''
        this.newPatientUnitName = ''
        this.newPatientUF = ''

        this.errPatientName = ''
        this.errPatientLastname = ''
        this.errPatientBirthdate = ''
        this.errPatientCpf = ''
        this.errPatientCNS = ''
        this.errPatientPhone = ''
        this.errPatientEmail = ''
        this.errPatientUnit = ''
        this.errPatientUF = ''
      },

      //
      //
      // ?
      //
      //

      setBirthdate (date, type)
      {
        /* if (date !== null)
        {
          const splitDate = date.split('/')

          // [06/02/25] console.log('::: Set Birthdate:', splitDate)
        } */
      },

      onCpfChange (val)
      {
        let v = String(val.target.value)

        // Remove tudo o que não é dígito
        v = v.replace(/[^0-9]/g, '')

        if (v.length === 0) {
          val.target.value = ''
          this.newPatientCpf = ''

          return false
        }

        v = v.replace(/(\d{3})(\d)/, '$1.$2')
        v = v.replace(/(\d{3})(\d)/, '$1.$2')
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
        v = v.slice(0, 14)

        val.target.value = v
        this.newPatientCpf = v

        return true
      },

      onCnsChange (val)
      {
        let v = String(val.target.value)

        // Remove tudo o que não é dígito
        v = v.replace(/[^0-9]/g, '')

        if (v.length === 0) {
          val.target.value = ''
          this.newPatientCNS = ''

          return false
        }

        // Aplica a formatação: 999 9999 9999 9999
        v = v.replace(/(\d{3})(\d)/, '$1 $2')
        v = v.replace(/(\d{4})(\d)/, '$1 $2')
        v = v.replace(/(\d{4})(\d)/, '$1 $2')
        v = v.slice(0, 18) // Garante que não passe de 15 dígitos + 3 espaços

        val.target.value = v
        this.newPatientCNS = v

        return true
      },

      onPhoneChange (val)
      {
        // [06/02/25] console.log('onPhoneChange:', this.newPatientPhone, val.target.value)

        let v = String(val.target.value)

        var len = 0

        // Remove tudo o que não é dígito
        v = v.replace(/[^0-9]/g, '')

        len = v.length

        if (len === 0 || len > 11) {
          const maskedPhone = applyPhoneMask(v || '')

          val.target.value = maskedPhone
          this.newPatientPhone = maskedPhone

          return false
        }

        // Coloca parênteses em volta dos dois primeiros dígitos
        v = v.replace(/^(\d\d)(\d)/g, '($1) $2')

        // Coloca hífen entre o quarto e o quinto dígitos
        if (len > 10) {
          v = v.replace(/(\d{5})(\d)/, '$1-$2').slice(0, 15)
        } else {
          v = v.replace(/(\d{4})(\d)/, '$1-$2').slice(0, 14)
        }

        val.target.value = v
        this.newPatientPhone = v

        return true
      },

      //
      //
      // ?
      //
      //

      openFindGroupDialog ()
      {
        this.$refs.modalFindGroup.open(this.newPatientUF)
      },

      //
      //
      // ?
      //
      //

      async patientPreRegister ()
      {
        if (this.loading) return false

        //

        this.errPatientName = ''
        this.errPatientLastname = ''
        this.errPatientBirthdate = ''
        this.errPatientCpf = ''
        this.errPatientCNS = ''
        this.errPatientPhone = ''
        this.errPatientEmail = ''
        this.errPatientUnit = ''
        this.errPatientUF = ''

        const firstName = String(this.newPatientName).trim()
        const lastName = String(this.newPatientLastname).trim()
        const dateOfBirth = String(this.newPatientBirthdate).trim()
        const cpf = String(this.newPatientCpf).trim()
        const cns = String(this.newPatientCNS).trim() // .replace(/[^0-9]/g, '')
        const phone = String(this.newPatientPhone).trim()
        const email = String(this.newPatientEmail).trim()
        const unitID = String(this.newPatientUnitId).trim()
        const groupID = String(this.newPatientUF).trim()

        if (firstName.length === 0) this.errPatientName = 'Preencha o nome'
        if (lastName.length === 0) this.errPatientLastname = 'Preencha o sobrenome'
        if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dateOfBirth)) this.errPatientBirthdate = 'Selecione a data de nascimento'

        if (cpf.length === 0 && cns.length === 0) {
          this.errPatientCpf = 'CPF e CNS pendentes.'
          this.errPatientCNS = 'CPF e CNS pendentes.'
        }
        // if (!validateBrazilianCpf(cpf) && cns.length !== 15) this.errPatientCNS = 'CPF e CNS pendente.'
        if (cpf.length > 0 && !validateBrazilianCpf(cpf)) this.errPatientCpf = 'Informe um CPF válido'
        if (cns.length > 0 && !validateBrazilianCNS(cns)) this.errPatientCNS = 'Informe um CNS válido'

        if (!/^\(\d{2}\) \d{4,5}-\d{4}$/.test(phone)) this.errPatientPhone = 'Informe um número nos formatos (99) 99999-9999 ou (99) 9999-9999'
        // if (!/^\(\d{2}\) \d{4,5}-\d{4}$/.test(phone)) this.errPatientPhone = 'Informe um número válido. Formatos: (99) 99999-9999 ou (99) 9999-9999.'

        if (email.length > 0 && !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) this.errPatientEmail = 'Informe um endereço de e-mail válido'
        if (unitID.length === 0) this.errPatientUnit = 'Selecione uma unidade de atendimento'
        if (groupID.length === 0) this.errPatientUF = 'Selecione um estado'

        if (
          this.errPatientName.length > 0 ||
          this.errPatientLastname.length > 0 ||
          this.errPatientBirthdate.length > 0 ||
          this.errPatientCpf.length > 0 ||
          this.errPatientCNS.length > 0 ||
          this.errPatientPhone.length > 0 ||
          this.errPatientEmail.length > 0 ||
          this.errPatientUnit.length > 0 ||
          this.errPatientUF.length > 0
        ) {
          return false
        }

        //
        //
        //

        this.loading = true

        const request = await apiCreatePatient({
          viewer_id: apiGetUserId(),
          group_id: groupID,
          first_name: firstName,
          last_name: lastName,
          date_of_birth: dateOfBirth,
          cpf,
          cns,
          phone,
          unit_id: unitID,
          email,
        })

        //
        // HOUVE ALGUM ERRO AO CRIAR PACIENTE
        //

        if (request.httpCode !== 201)
        {
          // SINALIZA FIM DO CARREGAMENTO/PROCESSAMENTO PARA A TELA
          this.loading = false
          return this.showMessage(request.title, request.message)
        }

        // ?
        // patientId: !!patient.id === true && patient.id !== 'null' ? String(patient.id).trim() : '',
        // patientFirstName: !!patient.first_name === true && patient.first_name !== 'null' ? String(patient.first_name).trim() : '',

        // SINALIZA FIM DO CARREGAMENTO/PROCESSAMENTO PARA A TELA
        this.loading = false

        // OUTPUT
        this.$emit('close', {
          id: request.data.id,
          first_name: firstName,
          last_name: lastName,
          date_of_birth: dateOfBirth,
          cpf,
          cns,
          email,
          group: String(this.newPatientUnitName).trim(),
          group_id: String(this.newPatientUnitId).trim(),
        })

        // phone,
        // group_id: groupId,

        this.visible = false
      },

      //
      //
      // CONFIRM DIALOG OUTPUT/RESPONSE
      //
      //

      async cdAction (cdResponse)
      {
        if (cdResponse === false) return

        // [06/02/25] console.log('::: cdAction:', cdResponse)

        /*
        const type = cdResponse.cdType
        const data = cdResponse.cdData

        if (type === 'confirmUndo')
        {
        }
        */
      },

      //
      //
      // SEARCH GROUP DIALOG RESPONSE
      //
      //

      dialogSearchGroupAction (cdResponse)
      {
        this.newPatientUnitId = cdResponse.groupId || ''
        this.newPatientUnitName = cdResponse.groupName || ''
      },
    },
  }

</script>

<style lang="scss">

  .registerPatientField
  {
    &.mx-datepicker
    {
      .mx-input {
        height: 38px;
        padding: 0;
        outline: 0;
        border: 0;
        border-radius: 0;
        box-shadow: none;

        font-size: 15px;
      }

      .mx-icon-calendar {
        display: none;
      }
    }
  }

</style>

<style scoped lang="scss">

  .err {
    display: inline-block;
    width: 100%;
    margin-top: 3px;
    margin-bottom: 10px;
    padding: 0 13px;

    color: indianred;
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;

    > span {
      display: inline-block;
      width: 100%;
    }

    &--notice {
      color: steelblue;
    }
  }

  .registerPatientTitle {
    margin-bottom: 10px;

    font-size: 20px;
    font-weight: 500;
    line-height: 25px;
  }

  .registerPatientForm {
    margin: -6px;
  }

  .registerPatientFieldIcon {
    z-index: 1;
    position: absolute;
    left: 20px;
    top: 0;
    bottom: 0;

    margin: auto 0;

    color: cadetblue;
  }

  .registerPatientField
  {
    width: 100%;
    height: 100%;
    padding: 0 20px 0 40px;
    outline: 0;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: 0 3px 5px -2px rgba(0, 0, 0, 0.15);
    background-color: #ffffff;

    // border: 1px solid rgba(0, 0, 0, 0.2);
    // box-shadow: 1px 2px 2px -1px rgba(0, 0, 0, 0.15);

    // border: 1px solid rgba(0, 0, 0, 0.25);

    color: #555555;
    font-size: 15px;

    &--noIcon {
      padding: 0 20px;
    }

    &--group {
      padding: 0 52px 0 40px;
    }

    &--noSpacing {
      padding: 0;
    }

    &:disabled {
      background-color: #CCCCCC;
    }
  }

  .registerPatientBlock {
    position: relative;

    width: 100%;
    height: 52px; // 40 + 12
    padding: 6px;

    &--left {
      padding-right: 6px;
    }

    &--right {
      padding-left: 6px;
    }

    &--50 {
      display: inline-block;
      vertical-align: middle;
      width: 50%;
    }

    &--verticalTop {
      vertical-align: top;
    }
  }

  .searchGroupButton {
    position: absolute;
    top: 12px;
    right: 12px;
  }

</style>
